import { LogService } from '../../services/log-service';
import { propertyCannotBeNullOrEmpty } from './message-props-builders/property-cannot-be-null-or-empty';
import { fulfillmentPlanCannotBeModified } from './message-props-builders/fulfillment-plan-cannot-be-modified';
import { subscriptionError } from './message-props-builders/subscription-errors';
import { usernameAlreadyExists } from './message-props-builders/username-already-exists';
import { loginErrors } from './message-props-builders/login-errors';
import { reportingCategoryErrors } from './message-props-builders/reporting-category-errors';
import { combineProductsErrors } from './message-props-builders/combine-product-errors';
import { thirdPartyTracking } from './message-props-builders/third-party-tracking';
import { insuranceErrors } from './message-props-builders/insurance-errors';
import { nonWalletProviderAccessError } from './message-props-builders/non-wallet-provider-access-error';
import { providerNotFoundError } from './message-props-builders/provider-not-found';
import { walletProviderApprovalPendingMessageBuilder } from './message-props-builders/wallet-provider-approval-pending';
import { enhancedReturnsErrorBuilder } from './message-props-builders/enhanced-returns-errors';

import {
  PropertyCannotBeNullOrEmpty,
  RequestFailedValidation,
  FulfillmentPlanCannotBeModified,
  SubscriptionLimitWouldBeExceeded,
  ActiveSubscriptionRequired,
  UsernameAlreadyExists,
  ExceededLoginAttempts,
  WorkstationLoginNotAuthorized,
  EmailNotYetVerified,
  ProductCategoryDuplicateName,
  ProductDuplicateSku,
  ThirdPartyTracking,
  InactiveInsuranceProvider,
  NonWalletProviderAccessFeatureRequired,
  ProviderNotFound,
  WalletProviderApprovalPending,
  HasExistingReturnRabbitAccount,
  StoreAlreadyRegisteredEnhancedReturns,
} from './code-constants';

const codeToMessageBuilders = {
  [PropertyCannotBeNullOrEmpty]: propertyCannotBeNullOrEmpty,
  [RequestFailedValidation]: propertyCannotBeNullOrEmpty,
  [FulfillmentPlanCannotBeModified]: fulfillmentPlanCannotBeModified,
  [SubscriptionLimitWouldBeExceeded]: subscriptionError,
  [ActiveSubscriptionRequired]: subscriptionError,
  [UsernameAlreadyExists]: usernameAlreadyExists,
  [ExceededLoginAttempts]: loginErrors,
  [WorkstationLoginNotAuthorized]: loginErrors,
  [EmailNotYetVerified]: loginErrors,
  [ProductCategoryDuplicateName]: reportingCategoryErrors,
  [ProductDuplicateSku]: combineProductsErrors,
  [ThirdPartyTracking]: thirdPartyTracking,
  [InactiveInsuranceProvider]: insuranceErrors,
  [NonWalletProviderAccessFeatureRequired]: nonWalletProviderAccessError,
  [ProviderNotFound]: providerNotFoundError,
  [WalletProviderApprovalPending]: walletProviderApprovalPendingMessageBuilder,
  [HasExistingReturnRabbitAccount]: enhancedReturnsErrorBuilder,
  [StoreAlreadyRegisteredEnhancedReturns]: enhancedReturnsErrorBuilder,
};

export const CodeToFormattedMessageProps = (code, errorContext, originalMessage, returnOriginalStringIfNoMatch = false) => {
  const messageBuilder = codeToMessageBuilders[code];
  const safeContext = errorContext || {};
  const fullContext = { ...safeContext, code, originalMessage };

  const message = messageBuilder?.(fullContext);
  if (message) {
    return message;
  }

  if (returnOriginalStringIfNoMatch) {
    return originalMessage;
  }

  LogService.logInfo('Nonfriendly Api Error', { originalMessage });
  return {
    defaultMessage: originalMessage,
    id: 'code-to-formatted-message-props.originalMessage',
  };
};
